
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/skireport",
      function () {
        return require("private-next-pages/[region]/skireport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/skireport"])
      });
    }
  